import { render, staticRenderFns } from "./translateProfileForm.vue?vue&type=template&id=2c8c5380&"
import script from "./translateProfileForm.vue?vue&type=script&lang=js&"
export * from "./translateProfileForm.vue?vue&type=script&lang=js&"
import style0 from "./translateProfileForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports